'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const debounce = require('lodash.debounce');
const ContextComponent = require('../../global/components/ContextComponent');

class StickyAlertPortal extends ContextComponent {
    constructor(props) {
        super(props);

        this._close = debounce(this._close, props.animationTime);

        this.state = {
            isOpen: props.isOpen,
        };
    }

    componentDidMount() {
        if (this.props.isOpen) {
            this._open(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { isOpen } = this.props;
        const isOpenChanged = isOpen !== nextProps.isOpen;

        if (isOpenChanged && nextProps.isOpen) {
            this._open(nextProps);
        } else if (isOpenChanged) {
            this._close(nextProps);
        }
    }

    _close({ isOpen }) {
        this.setState({ isOpen }, this.props.onClose);
    }

    _open({ isOpen }) {
        const { onOpen, animationTime } = this.props;
        this.setState({ isOpen }, debounce(onOpen, animationTime));
    }

    _shouldBeClosed() {
        return !this.state.isOpen;
    }

    render() {
        if (this._shouldBeClosed()) {
            return null;
        }

        return this.props.children;
    }
}

StickyAlertPortal.propTypes = {
    animationTime: PropTypes.number.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

StickyAlertPortal.defaultProps = {
    animationTime: 500,
    onOpen() {},
    onClose() {},
};

module.exports = StickyAlertPortal;



// WEBPACK FOOTER //
// ./assets/js/components/StickyAlert/StickyAlertPortal.jsx